import NotFoundPage from '@/pages/NotFoundPage';

export default [
  {
    path: '/404',
    name: 'NotFound',
    component: NotFoundPage
  },
  {
    path: '*',
    redirect: '/404'
  }
];
